export const CURRENCY_META = {
  ARS: { label: 'Pesos', short: 'ARS' },
  USD: { label: 'Dólares', short: 'USD' },
  EUR: { label: 'Euros', short: 'EUR' },
};

export function normalizeCurrency(currency) {
  const c = String(currency || 'ARS').toUpperCase();
  return CURRENCY_META[c] ? c : 'ARS';
}

export function getCurrencyBadgeClasses(currency, modoOscuro = false) {
  const c = normalizeCurrency(currency);
  const styles = {
    ARS: modoOscuro ? 'bg-gray-700/90 text-gray-200 border-gray-600' : 'bg-gray-100 text-gray-700 border-gray-200',
    USD: modoOscuro ? 'bg-emerald-950/70 text-emerald-200 border-emerald-800' : 'bg-emerald-50 text-emerald-800 border-emerald-200',
    EUR: modoOscuro ? 'bg-indigo-950/70 text-indigo-200 border-indigo-800' : 'bg-indigo-50 text-indigo-800 border-indigo-200',
  };
  return styles[c];
}

export function getCurrencyAccentBorder(currency, modoOscuro = false) {
  const c = normalizeCurrency(currency);
  const styles = {
    ARS: modoOscuro ? 'border-l-gray-500' : 'border-l-gray-400',
    USD: modoOscuro ? 'border-l-emerald-500' : 'border-l-emerald-500',
    EUR: modoOscuro ? 'border-l-indigo-500' : 'border-l-indigo-500',
  };
  return styles[c];
}
